import paths from "~/constants/paths";
import useCart from "~/composables/checkout/useCart";

export default defineNuxtRouteMiddleware(async (to, from) => {
  const isCartCollisionModalOpen = useState(
    "cart-collision-modal",
    () => false,
  );

  const { cart, cartCookie, isCartEmpty, initCart, claimCart } = useCart();
  const nuxtApp = useNuxtApp();
  const userToken = useCookie("hs-token");

  if (from.path === paths.login && to.path === paths.home && userToken.value) {
    const isOldCartEmpty = isCartEmpty.value;
    await initCart(nuxtApp.$baseUrl, !!cartCookie.value);

    if (cartCookie.value) {
      if (!nuxtApp.$features?.cart?.conflict_handling || isCartEmpty.value) {
        claimCart(cartCookie.value);
      } else if (cart.value && isOldCartEmpty) {
        cartCookie.value = cart.value.id;
      } else {
        isCartCollisionModalOpen.value = true;
      }
    }
  }
});
